import { render, staticRenderFns } from "./PuzzleStep.vue?vue&type=template&id=7b16d1dc&scoped=true"
import script from "./PuzzleStep.vue?vue&type=script&lang=js"
export * from "./PuzzleStep.vue?vue&type=script&lang=js"
import style0 from "./PuzzleStep.vue?vue&type=style&index=0&id=7b16d1dc&prod&scoped=true&lang=css"
import style1 from "./PuzzleStep.vue?vue&type=style&index=1&id=7b16d1dc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b16d1dc",
  null
  
)

export default component.exports